// extracted by mini-css-extract-plugin
export default {"container":"categoryBreakdown_container__Jrurn","innerCard":"categoryBreakdown_innerCard__s2KnU","table":"categoryBreakdown_table__uSsF6"};